<script setup lang="ts">
  import { SidebarMenuItem, SidebarMenuItemCustom } from '@gat-ship/shared'
  import { useGlobalSearchDialog } from '@gat-ship/search'
  import { accessCodes } from '@gat-ship/types'

  const { openSearchCommand } = useGlobalSearchDialog()
</script>

<template>
  <SidebarMenuItemCustom
    text="Search"
    :icon="$icons.menuIcons.SearchMenu"
    class="cursor-pointer"
    @click="openSearchCommand"
  >
    <template #after-text>
      <GatKeyboardShortcuts shortcut="ctrl + k" />
    </template>
  </SidebarMenuItemCustom>
  <SidebarMenuItem
    text="Dashboards"
    :icon="$icons.menuIcons.dashboard"
    :to="{ name: $routeDefinitions.dashboard.ex1 }"
  />
  <SidebarMenuItem
    v-if="
      $user.hasPermission(accessCodes.system.stakeholder.accessStakeholders)
    "
    text="Stakeholders"
    :icon="$icons.stakeholders.base"
    :to="{
      name: $routeDefinitions.stakeholders.overview
    }"
  />
  <SidebarMenuItem
    text="Mail Prototype"
    v-if="$featureFlag.hasFeatureFlag('mail-prototype')"
    :icon="$icons.common.Mail"
    :to="{ name: $routeDefinitions.mail.mailInbox }"
  />
</template>
